import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { pageService } from '../services/api';

function PublicPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPage = async () => {
      try {
        const data = await pageService.show(slug);
        setPage(data);
      } catch (error) {
        console.error('Error loading page:', error);
      } finally {
        setLoading(false);
      }
    };
    loadPage();
  }, [slug]);

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!page) return <div className="min-h-screen flex items-center justify-center text-gray-500">Page not found</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-xl font-bold text-gray-900">Ortus</Link>
          <div className="flex gap-4">
            <Link to="/shop" className="text-blue-600">Shop</Link>
            <Link to="/login" className="text-blue-600">Login</Link>
          </div>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold mb-6">{page.title}</h1>
        <div className="prose max-w-none">
          {page.content ? (
            <div dangerouslySetInnerHTML={{ __html: page.content }} />
          ) : (
            <p className="text-gray-500">No content available.</p>
          )}
        </div>
      </main>
    </div>
  );
}

export default PublicPage;
